import React from 'react'
import styles from './Footer.module.css'

const Footer: React.FC = () => {
    return (
        <footer className={styles.footer}>
            <small>Copyright &copy; 2023 foodsLabo by cuolega All rights reserved.</small>
            <div>
                <a href='https://foods-labo.com/privacy'>プライバシーポリシー</a>
                <a href='https://foods-labo.com/terms'>利用規約</a>
                <a href='https://cuolega.co.jp/profile/'>会社概要</a>
            </div>
        </footer>
    )
}

export default Footer

